// @flow strict
import * as React from 'react'
import { TwitterTweetEmbed } from 'react-twitter-embed'
import YouTube from 'react-youtube'
import InstagramEmbed from 'react-instagram-embed'

import styles from './SocialEmbeds.module.scss'

const SocialEmbeds = ({ type, id }: { type: string, id: string }) => {
  switch (type) {
    case 'Twitter':
      return (
        <div className={styles.embed}>
          <TwitterTweetEmbed tweetId={id} />
        </div>
      )
    case 'YouTube':
      return <YouTube videoId={id} id={id} containerClassName={styles.embed} />
    case 'Instagram':
      return (
        <div className={styles.embed}>
          <InstagramEmbed url={id} />
        </div>
      )
    default:
      return null
  }
}

export default SocialEmbeds
